var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSystemSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M20.703 19.468l-5.96-5.96c1.154-1.426 1.85-3.238 1.85-5.212C16.593 3.722 12.87 0 8.296 0 3.722 0 0 3.722 0 8.296c0 4.575 3.722 8.297 8.296 8.297 1.974 0 3.786-.696 5.212-1.85l5.96 5.96c.17.17.394.256.618.256.223 0 .447-.086.617-.256.342-.341.342-.893 0-1.235zM8.296 14.846c-3.612 0-6.55-2.938-6.55-6.55 0-3.612 2.938-6.55 6.55-6.55 3.612 0 6.55 2.938 6.55 6.55 0 3.612-2.938 6.55-6.55 6.55z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystemSearch);
export default __webpack_public_path__ + "static/media/system-search.370f126a.svg";
export { ForwardRef as ReactComponent };